export default __webpack_public_path__ + "static/media/Frame 196 (1).870ea6a9.svg";